export default "__VITE_ASSET__f42ee7bd__"